import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import ReactGA from 'react-ga'
import { RoleStr } from '../Commons/Utils'

export const CategoryStr = {
    REPORT: '작업보고',
    REPORT_COMMENT: '댓글',
    RFI: '요청사항',
    RFI_COMMENT: '댓글',
    RFI_RESPONSE: '요청사항 답변',
    POSTING: '회의록',
    POSTING_COMMENT: '댓글',
}

class AlarmItem extends Component {
    constructor(props) {
        super(props)
    }

    clickLink = (item) => {
        let landingUrl = '/'
        const menu = item.landing.menu
        const type = item.landing.type
        if (menu === 'REPORT' || menu === 'REPORT_COMMENT') {
            landingUrl = `/report/${item.landing._id}/`
        } else if (menu === 'POSTING' || menu === 'POSTING_COMMENT') {
            if (type === 'MEETING') {
                landingUrl = `/meeting/${item.landing._id}/`
            }
        } else if (menu === 'RFI' || menu === 'RFI_COMMENT' || menu === 'RFI_RESPONSE') {
            if (item.user_id === this.props.user._id) {
                // 건축주 요청
                landingUrl = `/demand/${item.landing._id}/`
            } else if (item.landing.assignee_id === this.props.user._id) {
                // 건축주 할일
                landingUrl = `/todo/${item.landing._id}/`
            }
        }
        this.props.history.push(landingUrl)
    }

    render() {
        //날짜 변환
        const newDate = new Date(this.props.alarm.createdAt)
        const newYear = newDate.getFullYear()

        let newMonth = newDate.getMonth() + 1
        if (newMonth < 10) {
            newMonth = '0' + newMonth
        }
        let newDay = newDate.getDate()
        if (newDay < 10) {
            newDay = '0' + newDay
        }

        return (
            <ul className="alarm_item">
                <div onClick={() => this.clickLink(this.props.alarm)}>
                    <li className="alarm_type">[새글]</li>
                    <li className="alarm_title">{this.props.alarm.title}</li>
                    <ul className="alarm_write_info">
                        <li className="alarm_posi">{CategoryStr[this.props.alarm.logType]}</li>
                        <li className="line" />
                        <li className="alarm_name">
                            {RoleStr[this.props.alarm.user.group]} {this.props.alarm.user.name}
                        </li>
                        <li className="line" />
                        <li className="alarm_date">
                            {newYear}.{newMonth}.{newDay}
                        </li>
                    </ul>
                </div>
            </ul>
        )
    }
}

class AlarmList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            list: null,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ user: res.data })
                this.loadAlarm()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadAlarm = () => {
        const { cookies } = this.props

        axios
            .get(`${BACKEND_HOST}/logs/?project_id=${cookies.get('project')}&limit=10`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                let alarms = []

                const list = res.data.data.filter((item) => {
                    if (['POSTING_COMMENT', 'REPORT_COMMENT'].includes(item.logType)) {
                        if (item.landing.accessLevel === 'PROJECT') return true
                        return false
                    }

                    if (item.logType === 'RFI_COMMENT') {
                        if (item.landing.assignee_id === this.state.user._id || item.user_id === this.state.user._id) {
                            return true
                        }
                        return false
                    }

                    return true
                })

                for (let i = 0; i < list.length; i += 1) {
                    const alarm = list[i]
                    const menu = alarm.landing.menu
                    const type = alarm.landing.type
                    if (
                        menu === 'RFI' ||
                        menu === 'REPORT' ||
                        menu === 'POSTING' ||
                        menu === 'RFI_COMMENT' ||
                        menu === 'RFI_RESPONSE' ||
                        menu === 'REPORT_COMMENT' ||
                        menu === 'POSTING_COMMENT'
                    ) {
                        if (menu === 'RFI') {
                            if (alarm.user_id === this.props.user._id) {
                                // 건축주 요청
                            } else if (alarm.landing.assignee_id === this.props.user._id) {
                                // 건축주 할일
                            } else {
                                continue
                            }
                        }
                        alarms.push(alarm)
                        if (alarms.length >= 4) {
                            break
                        }
                    }
                }

                this.setState({ list: alarms })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderAlarm = () => {
        const List = this.state.list.map((list) => {
            return (
                <AlarmItem
                    cookies={this.props.cookies}
                    history={this.props.history}
                    alarm={list}
                    key={list.id}
                    clickLink={this.clickLink}
                    user={this.props.user}
                />
            )
        })
        return List
    }

    render() {
        return (
            <div className="alarm_wrap box_wrap">
                <Link
                    to={'/notice/'}
                    onClick={() => {
                        ReactGA.event({ category: '대시보드_건축주', label: '새로운 알림', action: '더보기' })
                    }}>
                    <div className="box_more_btn">
                        더 보기
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
                            <path
                                fill="none"
                                fillRule="evenodd"
                                stroke="#A2A7AE"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.3"
                                d="M1.56.95L6.06 5l-4.5 4.05"
                            />
                        </svg>
                    </div>
                </Link>
                <h1>새로운 알림</h1>

                {this.state.list && this.state.list.length !== 0 ? (
                    <div className="alarm_list_wrap">{this.renderAlarm()}</div>
                ) : (
                    <div className="alarm_list_wrap_no">
                        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="56" viewBox="0 0 55 56">
                            <g
                                fill="none"
                                fillRule="evenodd"
                                stroke="#DEE3EB"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="3">
                                <path d="M18.44 4.592c6.525-3.51 14.514-3.452 20.983.151 6.469 3.603 10.444 10.21 10.44 17.351v11.477m-4.731 11.476H2c4.987 0 5.726-3.854 5.726-8.607V22.094a19.33 19.33 0 0 1 2.347-9.238m23.928 38.671c-1.077 1.77-3.06 2.859-5.207 2.859-2.146 0-4.13-1.09-5.207-2.859M3.45 4.888l49.313 46.205" />
                            </g>
                        </svg>
                        <p>새로운 알림이 없습니다.</p>
                    </div>
                )}
            </div>
        )
    }
}

export default withCookies(AlarmList)



// WEBPACK FOOTER //
// ./Src/Components/Dashboard/OwnerAlarmList.js